import React from 'react';
import { ImageOrigin, useGlobalContext } from '@honeycomb/data';
import { TypographyBody, TypographyHeading, Styler, FlexGrid2, PriceBlock, PriceBlockAmount, PriceBlockCaption, PriceBlockWasAmount, } from '@honeycomb/ui-core';
import { augmentImageUrl, getHotelImageBaseUrl } from '../../../utils/images';
export function HotelMapPopover({ staticDetails, pricingSummary }) {
    const { configSettings: { HotelImageCDN }, resourceStrings: { FROM }, } = useGlobalContext();
    const { name, geography, estabId } = staticDetails;
    const location = geography === null || geography === void 0 ? void 0 : geography.location;
    const priceFormatted = pricingSummary === null || pricingSummary === void 0 ? void 0 : pricingSummary.priceFormatted;
    const wasPriceFormatted = pricingSummary === null || pricingSummary === void 0 ? void 0 : pricingSummary.wasPriceFormatted;
    const baseUrl = getHotelImageBaseUrl(HotelImageCDN, estabId);
    const src = React.useMemo(() => augmentImageUrl(ImageOrigin.HotelImage, `${baseUrl}/0`, 'mapInfoWindow'), [baseUrl]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Styler, { "data-id": "map_hotel_image", pos: "relative", h: 110 },
            React.createElement("img", { style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }, src: src, alt: name, "aria-label": name })),
        React.createElement(Styler, { px: 3, py: 2 },
            React.createElement(FlexGrid2, { "data-id": "map_info_window", container: true, justifyContent: "space-between", spacing: 3, flexWrap: "nowrap" },
                React.createElement(FlexGrid2, null,
                    React.createElement(TypographyHeading, { component: "h4", size: "2xs", "data-id": "map_hotel_name" }, name),
                    React.createElement(TypographyBody, { size: "xs", "data-id": "map_hotel_location" }, location)),
                React.createElement(FlexGrid2, { alignSelf: "center" }, pricingSummary && (React.createElement(PriceBlock, { "data-id": "map_pricing_summery_block", size: "s" },
                    React.createElement(PriceBlockCaption, { "data-id": "map_pricing_summery_caption" }, FROM),
                    wasPriceFormatted && (React.createElement(PriceBlockWasAmount, { "data-id": "map_pricing_summery_was_price", size: "s" }, wasPriceFormatted)),
                    priceFormatted && (React.createElement(PriceBlockAmount, { "data-id": "map_pricing_summery_price", size: "xs" }, priceFormatted)))))))));
}
